class GrapesJsParser {
    constructor() {
        this.styleSheet = '';
    }

    // 主解析方法
    parse(data) {
        // 解析样式
        this.parseStyles(data.styles);

        // 解析页面内容
        const html = this.parsePages(data.pages);

        return {
            html,
            css: this.styleSheet
        };
    }

    // 解析样式
    parseStyles(styles) {
        let styleText = '';

        styles.forEach(style => {
            let selector = '';

            // 处理选择器
            if (style.selectorsAdd) {
                selector = style.selectorsAdd;
            } else if (style.selectors && style.selectors.length > 0) {
                selector = style.selectors.map(s => {
                    // 处理ID选择器
                    return s.startsWith('#') ? s : `.${s}`;
                }).join(', ');
            }

            if (!selector) return;

            // 处理状态
            if (style.state) {
                selector = `${selector}:${style.state}`;
            }

            // 处理样式属性
            const styleProps = Object.entries(style.style)
                .map(([prop, value]) => `${prop}: ${value};`)
                .join('\n  ');

            if (styleProps) {
                styleText += `${selector} {\n  ${styleProps}\n}\n`;
            }
        });

        this.styleSheet = styleText;
    }

    // 解析页面
    parsePages(pages) {
        return pages.map(page => this.parsePage(page)).join('\n');
    }

    // 解析单个页面
    parsePage(page) {
        return page.frames.map(frame => this.parseComponent(frame.component)).join('\n');
    }

    // 解析组件
    parseComponent(component) {
        if (!component) return '';

        // 处理文本节点
        if (component.type === 'textnode') {
            return component.content;
        }

        // 创建元素
        // const tagName = component.tagName || 'div';
        // component.type === 'image' ? 'img'
        // const tagName = component.type === 'link' ? 'a' : component.tagName || 'div';
        let tagName = 'div'
        if(component.tagName) {
            tagName = component.tagName
        }
        if(component.type === 'wrapper') {
            tagName = 'body'
        }
        if(component.type === 'link') {
            tagName = 'a'
        }
        if(component.type === 'image') {
            tagName = 'img'
        }
        let html = `<${tagName}`;

        // 添加类
        if (component.classes && component.classes.length) {
            html += ` class="${component.classes.join(' ')}"`;
        }

        // 添加属性
        if (component.attributes) {
            Object.entries(component.attributes).forEach(([key, value]) => {
                html += ` ${key}="${value}"`;
            });
        }

        html += '>';

        // 处理子组件
        if (component.components) {
            html += component.components.map(comp => this.parseComponent(comp)).join('');
        }

        // 处理内容
        if (component.content) {
            html += component.content;
        }

        // 闭合标签
        html += `</${tagName}>`;

        return html;
    }

    // 生成完整HTML文档
    generateDocument() {
        const { html, css } = this.parse(...arguments);
        return `
  <!DOCTYPE html>
  <html>
  <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <style>
  ${css}
      </style>
  </head>
  <body>
  ${html}
  </body>
  </html>`;
    }
}

// 使用示例
class GrapesJsRenderer {
    constructor(options = {}) {
        this.parser = new GrapesJsParser();
        this.options = {
            container: null,
            useIframe: false,
            injectStyles: true,
            ...options
        };
    }

    // 渲染到容器
    render(data, container = this.options.container) {
        const parsed = this.parser.parse(data);

        if (this.options.useIframe) {
            return this.renderInIframe(parsed, container);
        } else {
            return this.renderInContainer(parsed, container);
        }
    }

    // 在容器中渲染
    renderInContainer({ html, css }, container) {
        if (!container) {
            throw new Error('Container is required');
        }

        const targetContainer = typeof container === 'string' ?
            document.querySelector(container) : container;

        if (!targetContainer) {
            throw new Error('Container not found');
        }

        // 注入样式
        if (this.options.injectStyles && css) {
            const styleElement = document.createElement('style');
            styleElement.textContent = css;
            document.head.appendChild(styleElement);
        }

        // 渲染HTML
        targetContainer.innerHTML = html;
    }

    // 在iframe中渲染
    renderInIframe({ html, css }, container) {
        if (!container) {
            throw new Error('Container is required');
        }

        const targetContainer = typeof container === 'string' ?
            document.querySelector(container) : container;

        if (!targetContainer) {
            throw new Error('Container not found');
        }

        const iframe = document.createElement('iframe');
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        iframe.style.minHeight = '500px'
        iframe.style.border = 'none';

        targetContainer.appendChild(iframe);

        const doc = iframe.contentDocument;
        doc.open();
        doc.write(`
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <script type="text/javascript" src="https://code.iconify.design/1/1.0.7/iconify.min.js"></script>
            <script type="text/javascript" src="${process.env.VUE_APP_RESOURCE_URL}/js/bootstrap.bundle.min.js"></script>
            <script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.5.1/jquery.min.js"></script>
            <script src="${process.env.VUE_APP_RESOURCE_URL}/js/intlTelInput.min.js"></script>
            <link rel="stylesheet" href="${process.env.VUE_APP_RESOURCE_URL}/css/bootstrap.min.css">
            <link rel="stylesheet" href="${process.env.VUE_APP_RESOURCE_URL}/css/user_pages.css">
            <link rel="stylesheet" href="${process.env.VUE_APP_RESOURCE_URL}/css/video.css">
            <link rel="stylesheet" href="${process.env.VUE_APP_RESOURCE_URL}/css/countdown-v1.css">
            <link rel="stylesheet" href="${process.env.VUE_APP_RESOURCE_URL}/css/navigation-v1.css">
            <link rel="stylesheet" href="${process.env.VUE_APP_RESOURCE_URL}/css/checkout-v1.css">
            <link rel="stylesheet" href="${process.env.VUE_APP_RESOURCE_URL}/css/style-guide.css">
            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.15.0/css/all.css">
            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.15.0/css/v4-shims.css">
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.16/css/intlTelInput.css">
            <link rel="stylesheet"
                href="${process.env.VUE_APP_RESOURCE_URL}/css/checkout-v2.css">
            <link href="https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@400;700&display=swap" rel="stylesheet">
            <link href="https://fonts.googleapis.com/css2?family=Noto+Serif+SC:wght@400;700&display=swap" rel="stylesheet">
            <style>${css}</style>
        </head>
        ${html}
        <script src="${process.env.VUE_APP_RESOURCE_URL}/js/lazi-countdown.js"></script>
        <script src="${process.env.VUE_APP_RESOURCE_URL}/js/input_config.js"></script>
        <script src="${process.env.VUE_APP_RESOURCE_URL}/js/lazi-form.js"></script>
        <script src="${process.env.VUE_APP_RESOURCE_URL}/js/lazi-action-config.js"></script>
        <script src="${process.env.VUE_APP_RESOURCE_URL}/js/lazi-video.js"></script>
        </html>
      `);
        doc.close();

        return iframe;
    }
}
export default GrapesJsRenderer
// 使用示例
// const data = {/* 你的JSON数据 */ };

// // 方法1：直接解析
// const parser = new GrapesJsParser();
// const { html, css } = parser.parse(data);
// console.log('HTML:', html);
// console.log('CSS:', css);

// // 方法2：渲染到容器
// const renderer = new GrapesJsRenderer({
//     container: '#app',
//     useIframe: false,
//     injectStyles: true
// });

// renderer.render(data);

// // 方法3：生成完整文档
// const fullHtml = parser.generateDocument(data);
// console.log('Full HTML:', fullHtml);